__turbopack_context__.v({
  "footerLink": "CheckoutFooter-module-scss-module__EHH7QG__footerLink",
  "footerLinkItem": "CheckoutFooter-module-scss-module__EHH7QG__footerLinkItem",
  "footerLinks": "CheckoutFooter-module-scss-module__EHH7QG__footerLinks",
  "root": "CheckoutFooter-module-scss-module__EHH7QG__root",
});
